export const FRANCAIS = "fr";
export const ENGLISH = "en";